import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  elevated?: boolean;
  hover?: boolean;
}

export function Card({ elevated, hover, className, children, ...rest }: CardProps) {
  const cls = [
    "fd-card",
    elevated && "fd-card--elevated",
    hover && "fd-card--hover",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ children }: { children: ReactNode }) {
  return <div className="fd-card__header">{children}</div>;
}

export function CardTitle({ children }: { children: ReactNode }) {
  return <h3 className="fd-card__title">{children}</h3>;
}
